import { Injectable } from '@angular/core';
import { CanDeactivate, GuardsCheckEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { WorkflowMonitorService } from '../../../services/workflow-monitor/workflow-monitor.service';

@Injectable()
export class WorkflowMonitorGuard implements CanDeactivate<any> {
    private _nextUrl: string;
    constructor(private _workflowMonitorService: WorkflowMonitorService, private _router: Router) {
        this._router.events
            .pipe(filter<GuardsCheckEnd>((event) => event instanceof GuardsCheckEnd))
            .subscribe((event) => {
                this._nextUrl = event.url;
            });
    }

    public canDeactivate(): boolean {
        if (this._workflowMonitorService.isWorkflowInProgress) {
            this._workflowMonitorService.warn(() => this._router.navigateByUrl(this._nextUrl));
            return false;
        }
        return true;
    }
}
